import { render, staticRenderFns } from "./CustomerStatusBadge.vue?vue&type=template&id=4245738a&scoped=true"
import script from "./CustomerStatusBadge.vue?vue&type=script&lang=js"
export * from "./CustomerStatusBadge.vue?vue&type=script&lang=js"
import style0 from "./CustomerStatusBadge.vue?vue&type=style&index=0&id=4245738a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4245738a",
  null
  
)

export default component.exports